import { FC } from 'react'

import { Box, Link, Text } from '@factorialco/deprecated-design-system'
import { GetProcessesToAssignQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type ProcessesProcess = NonNullable<
  GetProcessesToAssignQuery['processes']['processesConnection']['nodes'][number]
>

interface Props {
  loading: boolean
  processes: ProcessesProcess[]
  areAllAssignable: boolean
}

const IncompleteProcessesBanner: FC<Props> = ({ loading, processes, areAllAssignable }) => {
  const noProcesses = processes.length === 0

  const linkText = noProcesses
    ? i18n.t('processes.tasks.import.no_workflows')
    : i18n.t('processes.tasks.import.link')

  if (loading) return null

  return (
    <>
      {areAllAssignable && (
        <Box paddingTop="s8">
          <Text.Normal color="radicalRed1000" size="100">
            {i18n.t('processes.tasks.import.form.workflows_not_configured')}
          </Text.Normal>
        </Box>
      )}

      <Box paddingTop="s8">
        <Link.Href target="_blank" href="/workflows" external={false}>
          {linkText}
        </Link.Href>
      </Box>
    </>
  )
}

export default IncompleteProcessesBanner
